import React from 'react'
import { profileSectionAnchorId } from './profileDetailSections'

export default function ProfileSectionAnchor({ id, children, className = '' }) {
  return (
    <section id={profileSectionAnchorId(id)} className={`scroll-mt-24 ${className}`}>
      {children}
    </section>
  )
}
